// FILE: src/services/learningSession.js
// Calls to the backend time engine (plan WP-3, POST /api/session/*). The
// client sends *where* the student is (the slide), never how long they spent:
// the server measures time itself.
import fetchWithAuth from "../utils/fetchWithAuth";
import { apiFetch } from "./api";

const post = (path, body = {}) =>
  fetchWithAuth(path, { method: "POST", body: JSON.stringify(body) });

export const startSession = (resourceId) => post("/api/session/start", { resourceId });

/** `resume: true` tells the server not to credit the gap since the last beat. */
export const heartbeat = (sessionId, location, resume = false) =>
  post(`/api/session/${sessionId}/heartbeat`, {
    ...(location ? { location } : {}),
    ...(resume ? { resume: true } : {})
  });

export const completeSession = (sessionId) => post(`/api/session/${sessionId}/complete`);

export const startBreak = () => post("/api/session/break/start");

/** Fire-and-forget end, safe to call while the page unloads. */
export function endSession(sessionId) {
  try {
    apiFetch(`/api/session/${sessionId}/end`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: "{}"
    }).catch(() => {});
  } catch {
    /* page is going away */
  }
}

/** The server's error body from a fetchWithAuth rejection (or {}). */
export function errorBody(err) {
  if (err?.body) return err.body;
  try {
    return JSON.parse(err?.message || "{}");
  } catch {
    return { code: err?.message };
  }
}
